import React, { createContext, useContext, useState, useCallback } from 'react';

const GuestContext = createContext();

const normalize = (s) =>
  s.trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\u0151/g, 'o').replace(/\u0171/g, 'u');

// Couples: add partner field with the partner's firstName to link two guests.
// When a guest logs in, their greeting will include their partner's name.
// To add a new couple, just add matching partner values to both guests.
const GUEST_LIST = [
  { firstName: 'Gergely', surname: 'Krista', special: 'gergely', aliases: ['Gergő', 'Gergo'], partner: 'Amiker' },
  { firstName: 'Amiker', surname: 'Best', special: 'amiker', partner: 'Gergely' },
  { firstName: 'Dávid', surname: 'Túri', special: 'david' },
  { firstName: 'Endre', surname: 'Feigl', special: 'endre' },
  { firstName: 'Ambrus', surname: 'Orbán', special: 'ambrus', displayName: 'Ambi' },
  { firstName: 'Mátyás', surname: 'Krista', special: 'matyas' },
  { firstName: 'Bence', surname: 'Kasu', special: 'bence' },
  { firstName: 'Máté', surname: 'Pál', special: 'mate' },
  { firstName: 'Calum', surname: 'Eadie', special: 'calum' },
  { firstName: 'Boldizsár', surname: 'Ljubicic', special: 'boldizsar' },
  { firstName: 'József', surname: 'Farkas', special: 'joco' },
  { firstName: 'Gábor', surname: 'Krista', partner: 'Gabriella' },
  { firstName: 'Gabriella', surname: 'Krista', partner: 'Gábor' },
  { firstName: 'Morag', surname: 'Best', special: 'morag', partner: 'Anthony' },
  { firstName: 'Anthony', surname: 'Best', special: 'anthony', partner: 'Morag' },
  { firstName: 'Dempsey', surname: 'Best' },
  { firstName: 'Natalie', surname: 'Best-Garrett' },
  { firstName: 'Sarah', surname: 'Yandell' },
  { firstName: 'Michael', surname: 'McGowan' },
  { firstName: 'Dipesh', surname: 'Patel', plusOne: true },
  { firstName: 'Baljinder', surname: 'Kang' },
  { firstName: 'Balázs', surname: 'Pavlik' },
  { firstName: 'Júlia', surname: 'Véglesi' },
  { firstName: 'Gyula', surname: 'Hodosi', special: 'gyula', plusOne: true },
  { firstName: 'Richárd', surname: 'Csernyi', plusOne: true },
  { firstName: 'Béla', surname: 'Kasu', partner: 'Barbara' },
  { firstName: 'Barbara', surname: 'Kasu', partner: 'Béla' },
  { firstName: 'Luca', surname: 'Kunsztler', plusOne: true },
  { firstName: 'Janka', surname: 'Kunsztler', plusOne: true },
  { firstName: 'Attila', surname: 'Rybicska', siblings: ['Emese'], plusOne: true },
  { firstName: 'Emese', surname: 'Rybicska', siblings: ['Attila'], plusOne: true },
  { firstName: 'Andrea', surname: 'Decsi' },
  { firstName: 'Anna', surname: 'Rybicska' },
  { firstName: 'Nóra', surname: 'Rybicska' },
  { firstName: 'Antal', surname: 'Rybicska' },
  { firstName: 'Fanni', surname: 'Debreczeni' },
  { firstName: 'Edina', surname: 'Antal' },
  { firstName: 'Bernadett', surname: 'Kiss' },
  { firstName: 'Seonaid', surname: 'Best', special: 'seonaid' },
  { firstName: 'Noah', surname: 'Cole' },
  { firstName: 'Elspeth', surname: 'Shields' },
  { firstName: 'Stefan', surname: 'Parpurov', partner: 'Aleksandra' },
  { firstName: 'Aleksandra', surname: 'Ciruk', partner: 'Stefan' },
  { firstName: 'Bee Bayo', surname: 'Adengonloye', aliases: ['Bayo', 'Bee'] },
  { firstName: 'James', surname: 'Mcleod', plusOne: true },
  { firstName: 'Iroh', surname: 'Best' },
  { firstName: 'Poopy', surname: 'Butthole' },
  { firstName: 'Gibbon', surname: 'Laci' },
  { firstName: 'Lewis', surname: 'Toland' },
  { firstName: 'Lauren', surname: 'Bell' },
  { firstName: 'David', surname: 'De Angelis' },
  { firstName: 'Iain', surname: 'Wells' },
  { firstName: 'Gillian', surname: 'Wells' },
  { firstName: 'Lewis', surname: 'Wells' },
  { firstName: 'Grace', surname: 'Jeffrey' },
  { firstName: 'Ross', surname: 'Wells' },
  { firstName: 'Abby', surname: 'Hunter' },
  { firstName: 'Laurie', surname: 'Wells' },
  { firstName: 'Gregor', surname: 'Wells' },
  { firstName: 'Lorna', surname: 'Wells' },
  { firstName: 'Rod', surname: 'Wells' },
  { firstName: 'Erin', surname: 'Wells' },
  { firstName: 'Steven', surname: 'Maclennan' },
  { firstName: 'Ruaraidh', surname: 'Wells' },
  { firstName: 'Paula', surname: 'Pappas' },
  { firstName: 'Tabatha', surname: 'Bazil' },
  { firstName: 'Samantha', surname: 'Carson' },
  { firstName: 'Windy', surname: 'Spearman-Best' },
  { firstName: 'Towanda', surname: 'Smith' },
  { firstName: 'Elina', surname: 'Takala' },
  { firstName: 'Kaa-Choon', surname: 'Ng', aliases: ['Choon'] },
  { firstName: 'Markus', surname: 'Barnes' },
  { firstName: 'Kinga', surname: 'Pavlik', surnameAliases: ['Odor'] },
  { firstName: 'Andy', surname: 'Herft', plusOne: true },
  { firstName: 'Stella', surname: 'Pickard', plusOne: true },
  { firstName: 'Jamien', surname: 'Steward', partner: 'Ciara' },
  { firstName: 'Ciara', surname: 'Golding', partner: 'Jamien' },
  { firstName: 'Terry', surname: 'Smith' },
];

const loadPairings = () => {
  try {
    const saved = localStorage.getItem('weddingPairings');
    return saved ? JSON.parse(saved) : {};
  } catch {
    return {};
  }
};

const buildGuestList = () => {
  const pairings = loadPairings();
  return GUEST_LIST.map((g) => {
    if (g.firstName in pairings) {
      return { ...g, partner: pairings[g.firstName] || undefined };
    }
    return g;
  });
};

const restoreGuest = (list) => {
  try {
    const saved = localStorage.getItem('weddingGuest');
    if (!saved) return null;
    const { firstName, surname } = JSON.parse(saved);
    return list.find(
      (g) => normalize(g.firstName) === normalize(firstName) && normalize(g.surname) === normalize(surname)
    ) || null;
  } catch {
    return null;
  }
};

const getPartnerName = (guest, list) => {
  if (!guest?.partner) return null;
  const partner = list.find(
    (g) => normalize(g.firstName) === normalize(guest.partner)
  );
  return partner ? (partner.displayName || partner.firstName) : guest.partner;
};

export const GuestProvider = ({ children }) => {
  const [guestList, setGuestList] = useState(buildGuestList);
  const [guest, setGuest] = useState(() => restoreGuest(guestList));

  const authenticate = useCallback((firstName, surname) => {
    const found = guestList.find(
      (g) => {
        const surnameMatch = normalize(g.surname) === normalize(surname) ||
          (g.surnameAliases && g.surnameAliases.some((a) => normalize(a) === normalize(surname)));
        const nameMatch = normalize(g.firstName) === normalize(firstName) ||
          (g.aliases && g.aliases.some((a) => normalize(a) === normalize(firstName)));
        return surnameMatch && nameMatch;
      }
    );

    if (found) {
      setGuest(found);
      localStorage.setItem('weddingGuest', JSON.stringify({ firstName: found.firstName, surname: found.surname }));
      return found;
    }
    return null;
  }, [guestList]);

  const logout = useCallback(() => {
    setGuest(null);
    localStorage.removeItem('weddingGuest');
  }, []);

  const updatePartner = useCallback((guestFirstName, partnerFirstName) => {
    const pairings = loadPairings();
    if (partnerFirstName) {
      pairings[guestFirstName] = partnerFirstName;
    } else {
      pairings[guestFirstName] = null;
    }
    localStorage.setItem('weddingPairings', JSON.stringify(pairings));
    setGuestList(buildGuestList());

    // Update current guest if their partner changed
    setGuest((prev) => {
      if (!prev) return prev;
      const updated = buildGuestList().find(
        (g) => normalize(g.firstName) === normalize(prev.firstName) && normalize(g.surname) === normalize(prev.surname)
      );
      return updated || prev;
    });
  }, []);

  const isAuthenticated = guest !== null;
  const partnerName = getPartnerName(guest, guestList);

  return (
    <GuestContext.Provider value={{ guest, isAuthenticated, authenticate, logout, partnerName, guestList, updatePartner }}>
      {children}
    </GuestContext.Provider>
  );
};

export const useGuest = () => {
  const context = useContext(GuestContext);
  if (!context) {
    throw new Error('useGuest must be used within a GuestProvider');
  }
  return context;
};
